<template>
  <v-btn
    small
    icon
    color="grey darken-2"
    @click="$emit('click')"
  >
    <v-icon small>mdi-arrange-send-backward</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'CloneButton',
};
</script>

<style scoped>

</style>
